<h2 *ngIf="!modalData?.trip?.timeSheetTripId && !modalData.timeSheetStatusError && isAdmin" mat-dialog-title>Add Trip</h2>
<h2 *ngIf="modalData?.trip?.timeSheetTripId && !modalData.timeSheetStatusError && isAdmin" mat-dialog-title>Edit Trip</h2>
<h2 *ngIf="modalData.timeSheetStatusError || (this.modalData?.trip?.timeSheetTripId && !isAdmin)" mat-dialog-title>Trip</h2>

<mat-error *ngIf="errorMessage" class="mb-1">{{ errorMessage }}</mat-error>

<div *ngIf="modalData?.timeSheetStatusError && !modalData?.timeSheetLockOutError">
	<mat-error>{{ modalData.timeSheetStatusError }}</mat-error>
</div>

<div *ngIf="modalData?.timeSheetLockOutError">
	<mat-error>{{ modalData.timeSheetLockOutError }}</mat-error>
</div>
<br />
<mat-dialog-content [formGroup]="form">
	<ng-container *ngIf="modalData?.trip?.tripVariesFromCmsData && modalData?.trip?.cmsOriginalLogPageNumber">
		<h2 mat-dialog-title>Original CMS Data</h2>

		<div *ngIf="modalData.trip.cmsOriginalTripStart !== modalData.trip.tripStart">
			<mat-form-field style="padding-right:0">
				<input
					matInput
					placeholder="Block Out (UTC)"
					type="datetime-local"
					disabled
					readonly
					style="width:initial;max-width:initial;"
					[value]="modalData.trip.cmsOriginalTripStart"
				/>
			</mat-form-field>
		</div>

		<div *ngIf="modalData.trip.cmsOriginalTripEnd !== modalData.trip.tripEnd">
			<mat-form-field>
				<input
					matInput
					placeholder="Block In (UTC)"
					type="datetime-local"
					disabled
					readonly
					style="width:initial;max-width:initial;"
					[value]="modalData.trip.cmsOriginalTripEnd"
				/>
			</mat-form-field>
		</div>

		<div *ngIf="modalData.trip.cmsOriginalTripNumber !== modalData.trip.tripNumber">
			<mat-form-field>
				<input
					matInput
					placeholder="Trip Number"
					type="text"
					disabled
					readonly
					[value]="modalData.trip.cmsOriginalTripNumber || '(Empty)'"
				/>
			</mat-form-field>
		</div>

		<div *ngIf="modalData.trip.cmsOriginalRouteInformation !== modalData.trip.routeInformation">
			<mat-form-field>
				<input
					matInput
					placeholder="Route Information"
					type="text"
					disabled
					readonly
					[value]="modalData.trip.cmsOriginalRouteInformation"
				/>
			</mat-form-field>
		</div>

		<div *ngIf="modalData.trip.cmsOriginalFlightMinutes !== modalData.trip.flightMinutes">
			<mat-form-field>
				<input
					matInput
					placeholder="Block Time"
					type="number"
					disabled
					readonly
					[value]="calculateFlightHours(modalData.trip.cmsOriginalFlightMinutes)"
				/>
			</mat-form-field>
		</div>

		<div *ngIf="modalData.trip.cmsOriginalLoadsUnloadsCount !== modalData.trip.loadsUnloadsCount">
			<mat-form-field>
				<input
					matInput
					placeholder="Loads/Unloads"
					type="number"
					disabled
					readonly
					[value]="modalData.trip.cmsOriginalLoadsUnloadsCount + ''"
				/>
			</mat-form-field>
		</div>
	</ng-container>

	<div layout-gt-xs="row" class="d-flex">
		<mat-form-field class="mr-3" fxFlex="50%">
			<input
				matInput
				[matDatepicker]="tripStartCalendar"
				[min]="minDateValue"
				[max]="maxStartDateValue"
				formControlName="tripStart"
				placeholder="Block Out (UTC)"
			/>
			<mat-datepicker-toggle matSuffix [for]="tripStartCalendar"> </mat-datepicker-toggle>
			<mat-datepicker [touchUi]="modalData.isMobile" #tripStartCalendar></mat-datepicker>
		</mat-form-field>
		<mat-error *ngIf="isSubmitted && form.get('tripStart').hasError('required')">
			Block Out date is required
		</mat-error>

		<div class="time-picker">
			<ngx-timepicker-field
				(change)="onTimeChange($event, 'startTime')"
				[format]="24"
				formControlName="startTime"
				[defaultTime]="form.get('startTime').value"
			></ngx-timepicker-field>
			<mat-error
				*ngIf="
					(isSubmitted || form.get('startTime').dirty) &&
					(form.get('startTime').hasError('required') || startTimeHoursError || startTimeMinutesError)
				"
			>
				Block out time time is required
			</mat-error>
		</div>
	</div>

	<div layout-gt-xs="row" class="d-flex">
		<mat-form-field class="mr-3" fxFlex="50%">
			<input
				matInput
				[matDatepicker]="tripEndCalendar"
				[min]="minDateValue"
				[max]="maxEndDateValue"
				formControlName="tripEnd"
				placeholder="Block In (UTC)"
			/>
			<mat-datepicker-toggle matSuffix [for]="tripEndCalendar"> </mat-datepicker-toggle>
			<mat-datepicker
				[startAt]="maxStartDateValue"
				[touchUi]="modalData.isMobile"
				#tripEndCalendar
			></mat-datepicker>
		</mat-form-field>
		<mat-error *ngIf="isSubmitted && form.get('tripEnd').hasError('required')">
			Block In date is required
		</mat-error>

		<div class="time-picker">
			<ngx-timepicker-field
				(change)="onTimeChange($event, 'endTime')"
				[format]="24"
				formControlName="endTime"
				[defaultTime]="form.get('endTime').value"
			></ngx-timepicker-field>
			<mat-error
				*ngIf="
					(isSubmitted || form.get('endTime').dirty) &&
					(form.get('endTime').hasError('required') || endTimeHoursError || endTimeMinutesError)
				"
			>
				Block In time is required
			</mat-error>
		</div>
	</div>

	<div layout-gt-xs="row">
		<mat-form-field class="input-full-width">
			<mat-select
				id="trip-type"
				name="trip-type"
				formControlName="tripType"
				placeholder="Trip Type"
				(selectionChange)="onTripTypeChange($event.value)"
			>
				<mat-option [value]="tripTypeEnum.Standard">Standard</mat-option>
				<mat-option [value]="tripTypeEnum.Broken">Broken</mat-option>
				<mat-option [value]="tripTypeEnum.Bypassed">Bypassed</mat-option>
				<mat-option [value]="tripTypeEnum.Canceled">Canceled</mat-option>
			</mat-select>
		</mat-form-field>
	</div>

	<div layout-gt-xs="row">
		<mat-form-field *ngIf="this.form.get('tripType').value == 'broken'" class="input-full-width">
			<input
				matInput
				placeholder="Broken Trip Count"
				formControlName="brokenTripCount"
				type="number"
				min="2"
				required
			/>
		</mat-form-field>
		<mat-error *ngIf="isSubmitted && form.get('brokenTripCount').hasError('required')">
			Broken trip count is required
		</mat-error>
		<mat-error *ngIf="form.get('brokenTripCount').hasError('min')">
			Broken trip count must be 2 or greater
		</mat-error>
	</div>

	<div layout-gt-xs="row">
		<mat-form-field class="input-full-width">
			<input matInput placeholder="Trip Number" formControlName="tripNumber" maxlength="50" />
		</mat-form-field>
	</div>

	<div layout-gt-xs="row">
		<mat-form-field class="input-full-width">
			<input matInput placeholder="Route" formControlName="routeInformation" maxlength="1000" required />
			<mat-error *ngIf="form.get('routeInformation').hasError('required')">
				Route is required
			</mat-error>
		</mat-form-field>
	</div>

	<div *ngIf="!modalData.currentEmployee.isLoadSpecialist" style="display:flex; gap:1rem; width:60%">
		<!-- <mat-form-field class="input-full-width">
			<input
				decimalOnly="singleDigitDecimalNumber"
				type="text"
				matInput
				placeholder="Block Time"
				formControlName="flightHours"
				required
			/>
			<mat-error *ngIf="form.get('flightHours').hasError('required')">
				Block Time is required
			</mat-error>
		</mat-form-field> -->

		<mat-form-field style="width:30%">
			<input
				matInput
				required
				numberOnly="positiveNumbers"
				type="number"
				placeholder="Block Time"
				formControlName="flightHours"
				min="0"
			/>
			<mat-error *ngIf="form.get('flightHours').hasError('required')">
				Block Time Hours is required
			</mat-error>
		</mat-form-field>
		<mat-label class="mt-1">hour(s)</mat-label>
		<mat-form-field style="width:30%">
			<input
				matInput
				numberOnly="positiveNumbers"
				type="number"
				formControlName="flightMinutes"
				max="59"
				min="0"
			/>
			<mat-error *ngIf="form.get('flightMinutes').hasError('required')">
				Block Time Minutes is required
			</mat-error>
		</mat-form-field>
		<mat-label class="mt-1">minute(s)</mat-label>
	</div>

	<div layout-gt-xs="row">
		<mat-form-field class="input-full-width">
			<input
				numberOnly="positiveNumbers"
				type="text"
				matInput
				placeholder="Load/Unloads"
				formControlName="loadsUnloadsCount"
				required
			/>
			<mat-error *ngIf="form.get('loadsUnloadsCount').hasError('required')">
				Loads/Unloads is required
			</mat-error>
		</mat-form-field>
	</div>

	<div layout-gt-xs="row">
		<mat-form-field class="input-full-width">
			<textarea matInput placeholder="Comments" formControlName="comments" maxlength="1000" required></textarea>
			<mat-error *ngIf="form.get('comments').hasError('required')">
				Comments are required
			</mat-error>
		</mat-form-field>
	</div>

	<mat-dialog-actions
		*ngIf="modalData && !modalData.timeSheetStatusError && !modalData.timeSheetLockOutError"
		fxLayoutAlign="end end"
	>
		<button
			*ngIf="modalData?.trip?.timeSheetTripId && modalData?.trip?.tripVariesFromCmsData &&
				isAdmin"
			class="mat-raised-button"
			[disabled]="!hasEdits()"
			(click)="removeEdits()"
		>
			Remove Edits
		</button>

		<button class="mat-raised-button" (click)="close()">
			Close
		</button>

		<button
			*ngIf="!modalData?.trip?.timeSheetTripId && isAdmin"
			class="mat-raised-button mat-primary"
			(click)="addTrip()"
			[disabled]="isSubmitted || form.invalid"
		>
			Save
		</button>

		<button
			*ngIf="modalData?.trip?.timeSheetTripId && !modalData?.trip?.cmsOriginalLogPageNumber &&
				isAdmin"
			class="mat-raised-button mat-warn"
			(click)="deleteTrip()"
		>
			Delete
		</button>

		<button
			*ngIf="modalData?.trip?.timeSheetTripId && isAdmin"
			class="mat-raised-button mat-primary"
			(click)="editTrip()"
			[disabled]="isSubmitted || form.pristine || form.invalid"
		>
			Save
		</button>
	</mat-dialog-actions>

	<div
		*ngIf="
			(modalData?.timeSheetStatusError && !modalData?.timeSheetLockOutError) || modalData?.timeSheetLockOutError
		"
	>
		<mat-dialog-actions fxLayoutAlign="end end">
			<button class="mat-raised-button" tabindex="-1" (click)="close()">Close</button>
		</mat-dialog-actions>
	</div>
</mat-dialog-content>
